function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 14.5,
  stroke: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.76 18.15c.013-.775.1-1.387.264-1.836.163-.45.495-.947.996-1.494L16.3 13.5c.546-.618.82-1.282.82-1.992 0-.683-.18-1.217-.538-1.601-.358-.39-.879-.586-1.562-.586-.664 0-1.198.176-1.602.527-.403.352-.605.824-.605 1.416h-1.807c.013-1.055.387-1.904 1.123-2.549.742-.65 1.706-.976 2.89-.976 1.231 0 2.188.332 2.872.996.69.657 1.035 1.562 1.035 2.715 0 1.139-.527 2.262-1.582 3.369l-1.064 1.054c-.476.528-.713 1.286-.713 2.276H13.76zm-.078 3.096c0-.293.088-.537.264-.733.182-.202.449-.303.8-.303.352 0 .619.101.801.303.182.195.274.44.274.733s-.092.537-.274.732c-.182.189-.45.283-.8.283-.352 0-.62-.094-.801-.283a1.054 1.054 0 01-.264-.732z",
  fill: "#fff"
});

const SvgFaqHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none"
}, props), _ref, _ref2);

export default SvgFaqHelp;